import { Col, Row } from "reactstrap"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard"
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"

const SubCategoriesDetails = ({ setToggleDetail }) => {
  const generalInfo = [
    { label: "Category ID", value: "#1234" },
    { label: "Category name", value: "#1234" },
    { label: "Description", value: "Full name" },
    { label: "Status", value: "03417053723" },
    { label: "No. of sub categories", value: "$50.00" },
    { label: "No. of products", value: "Shipped" },
  ]

  const auditTrailData = [
    { label: "Added date", value: "02/01/25 02:18 AM" },
    { label: "Last Modified", value: "02/01/25 02:18 AM" },
    { label: "Modified by", value: "Admin name" },
  ]

  const Dropdown = () => (
    <select className="form-select">
      <option value="1">Products</option>
    </select>
  )

  return (
    <div className="bg-white p-3 px-4 shadow">
      <ComponentBackButton onClick={() => setToggleDetail(prev => !prev.subCategory)}  />
      <div class="fw-semibold fs-4 text-center">Sub Category Details</div>

      <Row className="mt-3 gy-3 gy-xl-0 g-0">
        <Col xs={12} md={6} xl={4}>
          <InfoCard title="General Information" headerColor="#FBBD34" data={generalInfo}><Dropdown /></InfoCard>
        </Col>
      </Row>

      <Row className="mt-3 gy-3 gy-xl-0 g-0">
        <Col xs={12} md={6} xl={4}>
          <InfoCard title="Audit Trail" headerColor="#9B9B9B" data={auditTrailData} />
        </Col>
        <Col></Col>
        <Col xs={12} md={6} xl={4} className="d-flex justify-content-end">
          <div className="d-flex flex-column justify-content-center gap-2">
            <DynamicButton theme="gray">Delete Sub-Category</DynamicButton>
            <DynamicButton theme="yellow">Edit Sub-Category</DynamicButton>
            <DynamicButton theme="sky-blue">Change Status</DynamicButton>
            <DynamicButton theme="orange">Download Detail</DynamicButton>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SubCategoriesDetails
